import './Max.css';
export var maxValue = '_xxg5xc0-3-8-0';